import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/freightbooking/bookingsynclog'
import pathMap from 'src/paths/PathMap_FreightBooking'

class BookingSyncLogRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.BOOKING_SYNC_LOG_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.BOOKING_SYNC_LOG_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.BOOKING_SYNC_LOG_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.BOOKING_SYNC_LOG_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default BookingSyncLogRoute
